import { render } from "./ImAgreement.vue?vue&type=template&id=cf648872&scoped=true&ts=true"
import script from "./ImAgreement.vue?vue&type=script&lang=ts"
export * from "./ImAgreement.vue?vue&type=script&lang=ts"

import "./ImAgreement.vue?vue&type=style&index=0&id=cf648872&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf648872"]])

export default __exports__